import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';

import { PurchaseRequestService } from '../../services/purchase-request.service';
import { CatalogsSettingsService, PayrollId } from '../../services/catalogs-settings.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { CustomerSupplierService, CustomerSupplierId } from '../../services/customer-supplier.service';
import { UnitService, UnitId } from '../../services/unit.service';
import { WarehouseService, Warehouse } from '../../services/warehouse.service';

@Component({
  selector: 'app-create-purchase-request',
  templateUrl: './create-purchase-request.component.html',
  styleUrls: ['./create-purchase-request.component.css']
})
export class CreatePurchaseRequestComponent implements OnInit, OnDestroy {

  loggedUserId: string;
  loggedUserName: string;
  date: string;
  //requestedFolio: number;
  settings: PayrollId;

  prCmpas = {};
  prCmpasInit: any;
  prCmpaError: Boolean = false;
  productsError: Boolean = false;
  onEdit: number = -1;
  productsInRequest = [];
  wares: {name: string, prs: {[prById: string]: number} }[] = [];

  purchaseRequestForm: FormGroup;
  prForRequestForm: FormGroup;

  modalActionsPrForRequest = new EventEmitter<string|MaterializeAction>();
  modalParamsPrForRequest = [{dismissible: true}];
  
  prCmpasSub: Subscription;
  prCmpaSub: Subscription;
  userSub: Subscription;
  wareSub: Subscription;
  supplierSub: Subscription;
  customerSub: Subscription;
  
  pickadateParams = Utils.pickadateParams();

  constructor(
    private purchaseRequestService: PurchaseRequestService,
    private productionOrderService: ProductionOrderService,
    private customerService: CustomerSupplierService,
    private prCmpaService: ProductCmpaService,
    private authService: AuthService,
    private userService: UserService,
    private settingsService: CatalogsSettingsService,
    private unitService: UnitService,
    private supplierService: CustomerSupplierService,
    private wareService: WarehouseService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.createForm();
    this.createFormPrForOrder();

    this.loggedUserId = this.authService.currentUser.id;
    this.userSub = this.userService.getUser(this.loggedUserId).subscribe(user => {
      this.loggedUserName = user.name + ' ' + user.lastName;
      this.purchaseRequestForm.get('user').patchValue(this.loggedUserName);
    });
    this.date = this.getDate();
    this.purchaseRequestForm.get('date').patchValue(this.date);

    /* this.settingsSub = this.settingsService.getPayrollSettings('1').subscribe(settings => {
      let requesteds = settings.folios.purchaseRequestRequesteds || [];
      let lastFolio = settings.folios.purchaseRequest;
      this.settings = settings;
      if(!this.requestedFolio){
        this.requestedFolio = lastFolio + 1;
        while(requesteds.includes(this.requestedFolio)) this.requestedFolio++;
        this.purchaseRequestForm.get('folio').patchValue(this.requestedFolio);
        toast(`Se apartó el folio '${this.requestedFolio}' de configuración.`, 2000);
        console.log(`Se apartó el folio '${this.requestedFolio}' de configuración.`);
        requesteds.push(this.requestedFolio);
        settings.folios.purchaseRequestRequesteds = requesteds;
        this.settingsService.putPayrollSettings(<PayrollId>{folios: settings.folios}, '1');
      }
    }); */


    this.productionOrders = {};
    this.customerSub = this.customerService.getCustomers().subscribe(customers => {
      let productionOrderSub = this.productionOrderService.getProductionOrders().subscribe(productionOrders => {
        productionOrderSub.unsubscribe();
        this.rowsRead[0] = productionOrders.map(({id$, ...productionOrder}) => {
          let customerName = (customers.find(({id$: cId}) => productionOrder.customer.id == cId) || {name: ''}).name || '';
          return this.productionOrders[id$] = {id: id$,customerName, ...productionOrder}; 
        });
      });
    });

    this.supplierSub = this.supplierService.getSuppliers().subscribe(suppliers => {
      this.rowsRead[1] = suppliers.map(supplier => {
        supplier.id = supplier.id$;
        this.suppliers[supplier.id] = {...supplier};
        return supplier;
      });
    });

    this.wareSub = this.wareService.getWarehouses().subscribe((wares: Warehouse[]) => {
      this.wares = wares.map(({name, products}) => {
        let prs: {[id: string]: number} = {};
        for(let pr of products) prs[pr.ref.id] = pr.quantity || 0;
        return {name, prs};
      });
    });

    //Rerive data for autocomplete | productCmpa
    let unitSub = this.unitService.getUnits().subscribe(unitArray => {
      unitSub.unsubscribe();
      let units: {[id: string]: UnitId} = unitArray.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});
      this.prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {      
        const data = prCmpas.reduce((acc, cur) => {
          let characs = cur.characs.reduce((acc2, cur2, index) => {
            let {symbol = ''} = units[<string>cur2.unitId.id] || {};
            return `${acc2}${index ? ', ' : ''}${cur2.name.charAt(0)} ${cur2.value}${symbol ? ` ${symbol}` : ''}`;
          }, '');
          let fullName = `${cur.name} - ${characs} - ${cur.code}`.trim();
          acc[fullName] = null;
          this.prCmpas[fullName] = cur.id;
          this.prCmpas[`Unit of: ${fullName}`] = cur.unitRef ? units[<string> cur.unitRef.id].name : '';
          return acc;
        }, {});
        this.prCmpasInit = {
          'data': data
        }
      });
    });
  }

  ngOnInit() {
    if(localStorage.odpAuto){
      let {odp, prs} = JSON.parse(localStorage.odpAuto);
      delete localStorage.odpAuto;
      this.productsInRequest = prs;
      this.selectedProductionOrderId = odp;
    }
  }
  ngOnDestroy() {
    this.prCmpasSub.unsubscribe();
    this.wareSub.unsubscribe();
    if(this.userSub) this.userSub.unsubscribe();
    if(this.supplierSub) this.supplierSub.unsubscribe();
    if(this.customerSub) this.customerSub.unsubscribe();
  }
  createForm() {
    this.purchaseRequestForm = this.fb.group({
      user: ['', Validators.required],
      date: ['', Validators.required],
      deliveryRequiredDate: '',
      notes: '',
    });
  }
  createFormPrForOrder() {
    this.prForRequestForm = this.fb.group({
      name: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.min(1)]],
    });
  }

  showWaresPrId: string = '';
  onPrChange(): void {
    let prName = this.prForRequestForm.get('name').value;
    this.showWaresPrId = this.prCmpas[prName] || '';
  }
  openModalPrForRequest(index: number) {
    this.onEdit = index;
    this.showWaresPrId = '';
    this.prForRequestForm.reset();
    this.prCmpaError = false;
    if (index > -1) {
      this.prForRequestForm.get('name').setValue(this.productsInRequest[index].name);
      this.prForRequestForm.get('quantity').setValue(this.productsInRequest[index].quantity);
      this.onPrChange();
    }
    this.modalActionsPrForRequest.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrForRequest() {
    this.modalActionsPrForRequest.emit({ action: 'modal', params: ['close'] });
  }

  addPrForRequest({ value, valid }: { value: any, valid: boolean }) {
    if(this.prCmpas[value.name] == undefined){
      this.prCmpaError = true;
      this.prForRequestForm.get('name').setValue('');
    }else{
      value.productRef = this.prCmpas[value.name];
      value.unitName = this.prCmpas[`Unit of: ${value.name}`] || '';
      this.productsInRequest.push(value);
      this.closeModalPrForRequest();
    }
  }
  editPrForRequest({ value, valid }: { value: any, valid: boolean }, index: number) {
    this.productsInRequest[index].quantity = value.quantity;
    this.closeModalPrForRequest();
  }
  deletePrForRequest(index){
    this.productsInRequest.splice(index,1);
  }

  async onSubmit({ value } : { value: any }){
    //if(!this.selectedProductionOrderId) return toast('Seleccione una orden de producción', 2000);
    if(this.productsInRequest.length > 0) {
      this.productsInRequest.forEach(product => {
        delete product.name;
      });
      delete value.user;
      value.supplierRef = this.selectedSupplierId ? this.supplierService.getCustomerSupplierRef(this.selectedSupplierId) : null;
      value.productsInRequest = this.productsInRequest;
      value.requesterRef = this.loggedUserId;
      value.productionOrderRef = this.selectedProductionOrderId;
      value.folio = await this.settingsService.getNextFolioAndIncrement('purchaseRequest');
      this.purchaseRequestService.addPurchaseRequest(value);
      this.router.navigate([`/purchase_request`]);
    } else {
      this.productsError = true;
    }
  }
  /* async returnRequested(){
    let requestedIndex = this.settings.folios.purchaseRequestRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.purchaseRequestRequesteds.splice(requestedIndex, 1);
      await this.settingsService.putPayrollSettings(<PayrollId>{folios: this.settings.folios}, '1');
    }
    //this.service.windowReplace('read');
    //window.onbeforeunload = null;
  }
  updateSettings(){
    let requestedIndex = this.settings.folios.purchaseRequestRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.purchaseRequestRequesteds.splice(requestedIndex, 1);
    }
    if(this.requestedFolio > this.settings.folios.purchaseRequest) this.settings.folios.purchaseRequest = this.requestedFolio;
    this.settingsService.putPayrollSettings(this.settings, '1');
  } */

  getDate(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();

    var hh:string = today.getHours() + "";
    var min:string = today.getMinutes() + "";
    var ss:string = today.getSeconds() + "";
    if(+dd<10) {
      dd = '0'+dd;
    }
    if(+mm<10) {
      mm = '0'+mm;
    }
    if(+hh<10) {
      hh = '0'+hh;
    }
    if(+min<10) {
      min = '0'+min;
    }
    if(+ss<10) {
      ss = '0'+ss;
    }
    return yyyy + '-' + mm + '-' + dd;
  }




  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  //ProductionOrder
  productionOrders: any = {};
  selectedProductionOrderId: string = '';
  //Supplier
  suppliers: {[id: string]: CustomerSupplierId} = {};
  selectedSupplierId: string = '';


  get readValid(){ return this.selectedProductionOrderId };

  currentReadIndex: number;
  rowsRead = [[], []];
  columnsRead = [
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Cliente', name: 'customerName' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ],
    [//supplier
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
  ]

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentReadIndex == 0) this.selectedProductionOrderId = row.id;
    if(this.currentReadIndex == 1) this.selectedSupplierId = row.id;
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
